module.exports = __webpack_public_path__ + "img/final-preview.5e6db62e.jpg";